// valides if an email is properly formatted.
const validateIsEmail = (val: string): boolean =>
  /^[a-z0-9][a-z0-9-_.+]+@([a-z]|[a-z0-9]?[a-z0-9-]+[a-z0-9])\.[a-z0-9]{2,10}(?:\.[a-z]{2,10})?$/.test(
    val,
  )

export default validateIsEmail
